import { Condition, ConditionComparison, ValueSource } from '../../models/Condition';
import { OutputViewModel } from '../../models/viewModels/OutputViewModel';
import { PAYMENT_GENERATE_COMPONENT } from '../PaymentConstants';
import { PaymentStatus } from './Enums';
export const variableConditionPayment = 'input.content@content.value.amount';
export const variableConditionByType = 'input.content@content.value.type';
export const variableValuePaymentSuccess = 'application/vnd.iris.payment.success+json';
export const variableConditionPaymentType = 'input.content@content.type';
export const variableValuePaymentError = 'paymentError';
export const conditionOutputPayment = [
    new OutputViewModel({
        conditions: [
            new Condition({
                source: ValueSource.Context,
                variable: PAYMENT_GENERATE_COMPONENT,
                comparison: ConditionComparison.Equals,
                values: [PaymentStatus.Error],
            }),
        ],
        stateId: 'fallback',
        $invalid: false,
    }),
    new OutputViewModel({
        conditions: [
            new Condition({
                source: ValueSource.Context,
                variable: PAYMENT_GENERATE_COMPONENT,
                comparison: ConditionComparison.Equals,
                values: [PaymentStatus.Success],
            }),
        ],
        stateId: '',
        $invalid: false,
    }),
];
